/* Lulla product page + site-wide cart drawer. Source: Lulla-PDP-Build (design canvas port). */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (cents) => {
    const d = cents / 100;
    return '$' + (Number.isInteger(d) ? d : d.toFixed(2));
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const json = (url, opts) => fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts)).then(async (r) => {
    const body = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(body.description || body.message || 'Something went wrong');
    return body;
  });
  // Clarity custom events + session tags (filterable in recordings and the dashboard); never let tracking break the page
  // Christmas line in the buy box: "Order by 15 Dec…" until the last two weeks, then a countdown, then gone (Brisbane dates;
  // the section also stops rendering it after the cutoff). The cutoff is the buy box's "Christmas order cutoff" setting.
  document.querySelectorAll('[data-xmas]').forEach((el) => {
    const [y, m, d] = el.dataset.xmas.split('-').map(Number);
    const bne = new Date(Date.now() + 10 * 3600e3);  // Brisbane is UTC+10 all year
    const left = Math.round((Date.UTC(y, m - 1, d) - Date.UTC(bne.getUTCFullYear(), bne.getUTCMonth(), bne.getUTCDate())) / 864e5);
    const text = el.querySelector('[data-xmas-text]');
    const b = text && text.querySelector('b');
    if (left < 0) { el.remove(); return; }
    if (!text || !b || left > 14) return;
    const style = b.getAttribute('style');
    text.innerHTML = left === 0 ? `<b style="${style}">Last day</b> to order for Christmas delivery`
      : `Order in the next <b style="${style}">${left + 1} days</b> for Christmas delivery`;
  });

  const clarityEvent = (name, tags) => {
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('event', name);
      Object.entries(tags || {}).forEach(([k, v]) => window.clarity('set', k, String(v)));
    } catch (e) { /* ignore */ }
  };

  /* ---------- stacked card decks ---------- */
  document.querySelectorAll('[data-deck-root]').forEach((deckRoot) => {
    const cards = [...deckRoot.querySelectorAll('[data-card]')];
    const dots = [...deckRoot.querySelectorAll('[data-dot]')];
    const n = cards.length;
    let i = 0;
    const paint = () => {
      cards.forEach((c, k) => {
        const r = (k - i + n) % n;
        const v = Math.min(r, 2);
        c.style.zIndex = n - r;
        c.style.opacity = r > 2 ? 0 : [1, 0.85, 0.6][r];
        c.style.transform = `translateY(${v * 14}px) scale(${1 - v * 0.04})`;
        c.setAttribute('aria-hidden', r ? 'true' : 'false');
      });
      dots.forEach((d, k) => {
        d.style.width = k === i ? '22px' : '6px';
        d.style.background = k === i ? '#1c1816' : '#d8c9bb';
      });
    };
    const go = (step) => { i = (i + step + n) % n; paint(); };
    const deck = deckRoot.querySelector('[data-deck]');
    if (deck) deck.addEventListener('click', () => go(1));
    const next = deckRoot.querySelector('[data-deck-next]');
    const prev = deckRoot.querySelector('[data-deck-prev]');
    if (next) next.addEventListener('click', (e) => { e.stopPropagation(); go(1); });
    if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); go(-1); });
    paint();
  });

  /* ---------- 93% count-up, once, when the ring scrolls into view ---------- */
  document.querySelectorAll('[data-count]').forEach((ring) => {
    const num = ring.querySelector('.pr-num');
    const target = +ring.dataset.count;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    ring.style.setProperty('--off', 100);
    if (num) num.style.setProperty('--pct', 0);
    const io = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      requestAnimationFrame(() => {
        ring.style.setProperty('--off', 100 - target);
        if (num) num.style.setProperty('--pct', target);
      });
    }, { threshold: 0.6 });
    io.observe(ring);
  });

  /* ---------- sections fade up once as they reach the fold ---------- */
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const els = [...document.querySelectorAll('.ld > section:not(.lv-hero) > *, .ld .sb-item')];
    els.forEach((el) => { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in', 'is-done'); });
    document.documentElement.classList.add('ld-fade');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-in');
        setTimeout(() => e.target.classList.add('is-done'), 1600);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.filter((el) => !el.classList.contains('is-in')).forEach((el) => io.observe(el));
  })();

  /* ---------- heartbeat player ---------- */
  document.querySelectorAll('[data-beat-toggle]').forEach((btn) => {
    const box = btn.closest('.sb-player');
    const sub = box && box.querySelector('[data-beat-sub]');
    const bars = box && box.querySelector('[data-beat-bars]');
    let audio;
    const set = (on) => {
      btn.querySelector('[data-beat-play]').toggleAttribute('hidden', on);
      btn.querySelector('[data-beat-pause]').toggleAttribute('hidden', !on);
      btn.setAttribute('aria-label', on ? 'Pause heartbeat' : 'Play heartbeat');
      if (sub) sub.textContent = on ? 'Playing · recorded from a real Lulla soundbox' : 'Tap play, with your sound on';
      if (bars) bars.style.setProperty('--ps', on ? 'running' : 'paused');
    };
    btn.addEventListener('click', () => {
      if (!audio) { audio = new Audio(btn.dataset.src); audio.loop = true; }
      if (!audio.paused) { audio.pause(); set(false); return; }
      audio.play().then(() => set(true)).catch(() => set(false));
    });
    // people tap the whole player row and the soundbox photo expecting sound (Clarity dead clicks), so both play too;
    // the button stays the keyboard and screen-reader control
    const sec = btn.closest('.sb');
    [box, sec && sec.querySelector('.sb-stage')].forEach((el) => el && el.addEventListener('click', (e) => {
      if (!e.target.closest('[data-beat-toggle]')) btn.click();
    }));
  });

  /* ---------- buy box ---------- */
  document.querySelectorAll('[data-lulla-product]').forEach((sec) => {
    const scope = sec.closest('.ld') || sec;
    const track = sec.querySelector('[data-gal-track]');
    const thumbs = [...sec.querySelectorAll('[data-gal-thumb]')];
    const cta = sec.querySelector('.buy-cta');
    const sticky = scope.querySelector('[data-sticky]');
    let gi = Math.max(0, thumbs.findIndex((t) => t.classList.contains('is-active')));
    let price = +sec.dataset.basePrice || 0; // products without colour pills (Elephant) never call applyVariant

    // gallery: a row of photos you drag with a finger (or mouse); thumbnails and colour picks scroll it
    const slides = track ? [...track.children] : [];
    const strip = thumbs.length ? thumbs[0].parentElement : null;
    const mark = () => {
      thumbs.forEach((x, k) => x.classList.toggle('is-active', k === gi));
      const t = thumbs[gi];
      if (strip && t) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
    };
    const show = (idx) => {
      if (!slides[idx] || slides[idx].hidden) return;
      gi = idx;
      track.scrollTo({ left: slides[gi].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      mark();
    };
    // nearest visible photo to the current scroll position (hidden variant photos take no space)
    const nearest = () => {
      let best = gi;
      let dist = Infinity;
      slides.forEach((s, k) => {
        if (s.hidden) return;
        const d = Math.abs(s.offsetLeft - slides[0].offsetLeft - track.scrollLeft);
        if (d < dist) { dist = d; best = k; }
      });
      return best;
    };
    // variant photos stay hidden unless that variant is picked
    const reveal = (mediaId) => {
      slides.forEach((s, k) => {
        if (!s.hasAttribute('data-variant-media')) return;
        const on = s.dataset.mediaId === String(mediaId);
        s.hidden = !on;
        if (thumbs[k]) thumbs[k].hidden = !on;
      });
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    if (track && slides.length > 1) {
      let settle;
      track.addEventListener('scroll', () => {
        clearTimeout(settle);
        settle = setTimeout(() => {
          const k = nearest();
          if (k !== gi) { gi = k; mark(); }
        }, 80);
      }, { passive: true });
      // mouse: grab and drag like a finger, then snap to the nearest photo
      let dragX = null;
      let dragLeft = 0;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        dragX = e.clientX;
        dragLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', (e) => {
        if (dragX === null) return;
        track.scrollLeft = dragLeft - (e.clientX - dragX);
      });
      window.addEventListener('pointerup', () => {
        if (dragX === null) return;
        dragX = null;
        track.classList.remove('is-dragging');
        show(nearest());
      });
      track.addEventListener('dragstart', (e) => e.preventDefault());
    }

    const ups = [...sec.querySelectorAll('[data-upsell]')];
    const label = () => {
      const on = ups.filter((u) => u.getAttribute('aria-checked') === 'true');
      const count = on.length + 1;
      if (ups.some((u) => u.hasAttribute('data-addon'))) {  // add-ons (carry cot, spare soundbox): the button keeps its own words
        if (cta) cta.textContent = cta.dataset.label;
        if (sticky) sticky.textContent = sec.dataset.stickyLabel || 'Add to cart';
        return;
      }
      if (cta) cta.textContent = count > 1 ? `Get ${count} Lullas` : cta.dataset.label;
      // cross-sell heading names the next Lulla saving (same tiers as the cart goal bar)
      const head = sec.querySelector('[data-ups-head]');
      if (head) {
        const goals = JSON.parse((document.querySelector('[data-lulla-cart]') || { dataset: {} }).dataset.goals || '[]');
        const g = goals[on.length];
        if (goals.length) head.textContent = g ? `${on.length ? 'Add another' : 'Add'} & save $${g[1]}` : `You’re saving $${goals[goals.length - 1][1]}!`;
      }
      if (sticky) sticky.textContent = count > 1 ? `Get ${count} Lullas` : (sec.dataset.stickyLabel || 'Add to cart');
    };
    // gift wrap (28 Oct 2026): ticking it opens an optional gift message that rides on the gift wrap line
    const giftNote = sec.querySelector('[data-gift-note]');
    const giftSync = () => { const g = ups.find((u) => u.hasAttribute('data-gift')); if (giftNote) giftNote.hidden = !(g && g.getAttribute('aria-checked') === 'true'); };
    ups.forEach((u) => u.addEventListener('click', () => {
      u.setAttribute('aria-checked', u.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      label();
      giftSync();
      if (u.hasAttribute('data-gift')) clarityEvent(u.getAttribute('aria-checked') === 'true' ? 'buybox_gift_on' : 'buybox_gift_off');
    }));
    if (giftNote) giftNote.querySelector('[data-gift-text]').addEventListener('change', (e) => { if (e.currentTarget.value.trim()) clarityEvent('gift_message_typed', { gift_from: 'buybox' }); });

    // d: { variantId, price, compare, name, mediaId, available } from a colour pill or the Duo pickers
    const applyVariant = (d) => {
      sec.dataset.variantId = d.variantId;
      price = +d.price;
      const cmp = +d.compare;
      scope.querySelectorAll('[data-colour-name]').forEach((el) => { el.textContent = d.name; });
      // only the price labels: colour pills and add-on toggles carry data-price/data-compare as values
      scope.querySelectorAll('[data-price]:not(button)').forEach((el) => { el.textContent = money(price); });
      scope.querySelectorAll('[data-compare]:not(button)').forEach((el) => { el.textContent = cmp > price ? money(cmp) : ''; });
      const save = sec.querySelector('[data-save]');
      if (save) { save.textContent = 'SAVE ' + money(cmp - price); save.hidden = !(cmp > price); }
      const q = sec.querySelector('[data-quarter]');
      if (q) q.textContent = '$' + (price / 400).toFixed(2);
      if (d.mediaId) reveal(d.mediaId);
      const k = thumbs.findIndex((t) => t.dataset.mediaId === String(d.mediaId));
      if (k >= 0 && d.scroll !== false) show(k);
      const ok = d.available === true || d.available === 'true';
      scope.querySelectorAll('[data-add-to-cart]').forEach((b) => { b.disabled = !ok; });
      label();
    };
    const pick = (sw) => {
      sec.querySelectorAll('.sw').forEach((x) => x.setAttribute('aria-pressed', x === sw ? 'true' : 'false'));
      applyVariant({ variantId: sw.dataset.variantId, price: sw.dataset.price, compare: sw.dataset.compare, name: sw.dataset.name, mediaId: sw.dataset.mediaId, available: sw.dataset.available });
    };
    sec.querySelectorAll('.sw').forEach((sw) => sw.addEventListener('click', () => pick(sw)));

    // Duo: first + second Lulla pickers resolve to one of the Duo product's variants for price and photo only; the button adds
    // the two picks as separate single Lullas (Shopify's automatic Duo discount brings them to the Duo price) and is enabled
    // by the singles' stock. The Duo product itself is never added to the cart.
    // Any other product with option rows (the basic buy box) just resolves the rows to a variant and adds that.
    const vjson = sec.querySelector('[data-variants]');
    let duoItems = null;
    if (vjson) {
      const variants = JSON.parse(vjson.textContent);
      const isDuo = variants.some((x) => /^Lulla /.test(x.options[0] || ''));
      const SINGLE = { Pup: 'sleepy-dog-bundle', Elephant: 'sleepy-elephant-bundle', Bunny: 'sleepy-bunny-bundle', Doll: 'lulla-sleepy-baby-2-bundle' };
      const singles = {};
      if (isDuo) Object.values(SINGLE).forEach((h) => { singles[h] = json(root + 'products/' + h + '.js').catch(() => null); });
      const single = async (val) => {  // "Lulla Bunny - Soothing grey" -> the Sleepy Bunny Bundle's Soothing Grey variant
        const m = /^Lulla (\w+)(?: - (.+))?$/.exec(val);
        const p = m && SINGLE[m[1]] && await singles[SINGLE[m[1]]];
        return (p && (m[2] ? p.variants.find((x) => x.title.toLowerCase() === m[2].toLowerCase()) : p.variants[0])) || null;
      };
      const picks = () => [...sec.querySelectorAll('.duo-pick')].map((g) => (g.querySelector('.duo-sw[aria-pressed="true"]') || g.querySelector('.duo-sw')).dataset.value);
      if (isDuo) duoItems = async () => {
        const vs = await Promise.all(picks().map(single));
        if (vs.some((v) => !v || !v.available)) throw new Error('Sorry, one of those Lullas is sold out right now. Please pick another.');
        return vs[0].id === vs[1].id ? [{ id: vs[0].id, quantity: 2 }] : vs.map((v) => ({ id: v.id, quantity: 1 }));
      };
      const duoStock = async () => {  // grey the button out when either pick is sold out
        if (!isDuo) return;
        const vs = await Promise.all(picks().map(single));
        const ok = vs.every((v) => v && v.available);
        scope.querySelectorAll('[data-add-to-cart]').forEach((b) => { b.disabled = !ok; });
      };
      const groups = [...sec.querySelectorAll('.duo-pick')];
      const preRe = sec.dataset.preMatch ? new RegExp(sec.dataset.preMatch, 'i') : null;
      const choose = (scroll = true) => {
        const vals = groups.map((g) => (g.querySelector('.duo-sw[aria-pressed="true"]') || g.querySelector('.duo-sw')).dataset.value);
        groups.forEach((g, i) => { const n = g.querySelector('[data-opt-name]'); if (n) n.textContent = vals[i]; });
        const v = variants.find((x) => vals.every((val, i) => x.options[i] === val));
        if (!v) return;
        const isPre = !!preRe && vals.some((x) => preRe.test(x));
        const note = sec.querySelector('[data-duo-pre]');
        if (note) note.hidden = !isPre;
        if (cta && sec.dataset.preLabel) cta.dataset.label = isPre ? sec.dataset.preLabel : sec.dataset.liveLabel;
        if (sec.dataset.preLabel) sec.dataset.stickyLabel = isPre ? 'Pre-order' : 'Add to cart';
        applyVariant({ variantId: v.id, price: v.price, compare: v.compare_at_price || 0, name: vals.map((x) => x.replace(/^Lulla /, '')).join(isDuo ? ' + ' : ' / '),
          mediaId: v.featured_media && v.featured_media.id, available: isDuo || v.available, scroll });
        duoStock();
      };
      groups.forEach((g) => g.querySelectorAll('.duo-sw').forEach((b) => b.addEventListener('click', () => {
        g.querySelectorAll('.duo-sw').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
        choose();
        const pair = groups.map((x) => (x.querySelector('.duo-sw[aria-pressed="true"]') || {}).dataset.value).join(' + ');
        if (isDuo) clarityEvent('duo_pick', { duo_pair: pair });
        if (preRe && preRe.test(pair)) clarityEvent('duo_pick_preorder');
      })));
      choose(false);
    }
    const first = sec.querySelector('.sw[aria-pressed="true"]') || sec.querySelector('.sw');
    if (first) { price = +first.dataset.price; label(); }

    scope.querySelectorAll('[data-add-to-cart]').forEach((btn) => btn.addEventListener('click', async () => {
      const items = duoItems ? await duoItems() : [{ id: +sec.dataset.variantId, quantity: 1 }];
      const giftMsg = giftNote ? giftNote.querySelector('[data-gift-text]').value.trim() : '';
      ups.filter((u) => u.getAttribute('aria-checked') === 'true').forEach((u) => items.push(
        u.hasAttribute('data-gift') && giftMsg ? { id: +u.dataset.variantId, quantity: 1, properties: { 'Gift message': giftMsg } } : { id: +u.dataset.variantId, quantity: 1 }));
      // hidden line property (underscore = not shown to the shopper) so orders show where each Lulla was added
      items.forEach((it) => { it.properties = Object.assign({}, it.properties, { _added_from: duoItems ? 'duo_page' : 'buybox' }); });
      const was = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        await json(root + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items }) });
        clarityEvent('add_to_cart');
        clarityEvent('add_to_cart_buybox', { atc_product: location.pathname.split('/').pop(), atc_upsells: ups.filter((u) => u.getAttribute('aria-checked') === 'true').length, atc_gift: ups.some((u) => u.hasAttribute('data-gift') && u.getAttribute('aria-checked') === 'true') ? 'yes' : 'no' });
        ups.forEach((u) => u.setAttribute('aria-checked', 'false'));
        if (giftNote) { giftNote.querySelector('[data-gift-text]').value = ''; giftSync(); }
        await new Promise((res) => { document.dispatchEvent(new CustomEvent('lulla:cart-open', { detail: { done: res } })); setTimeout(res, 6000); });  // resolves once the drawer is in
        label();
      } catch (e) {
        btn.textContent = was;
        alert(e.message);
      } finally {
        btn.disabled = false;
        if (btn.textContent === 'Adding…') label();
      }
    }));

  });

  /* ---------- "Choose another character": fetch the next product page on touch/hover so the jump feels instant ---------- */
  const fetched = new Set();
  document.querySelectorAll('.cx-i[href]').forEach((a) => {
    const warm = () => {
      if (a.classList.contains('is-on') || fetched.has(a.href)) return;
      fetched.add(a.href);
      const l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href.split('#')[0];
      document.head.appendChild(l);
    };
    a.addEventListener('pointerenter', warm);
    a.addEventListener('touchstart', warm, { passive: true });
    a.addEventListener('click', () => clarityEvent('character_switch', { switched_to: a.textContent.trim() }));
  });

  /* ---------- Lulla Cub notify form: the coming soon card opens this instead of a product page ---------- */
  const cubEl = document.querySelector('[data-cub-notify]');
  if (cubEl) {
    const cubForm = cubEl.querySelector('[data-cub-form]');
    const cubErr = cubEl.querySelector('[data-cub-err]');
    const cubClose = () => { cubEl.hidden = true; document.documentElement.style.overflow = ''; };
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-cub-open]')) return;
      cubEl.querySelector('.cn-photo').loading = 'eager';
      cubEl.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      clarityEvent('cub_card_tap');
      cubForm.email && !cubForm.hidden && cubForm.email.focus({ preventScroll: true });
    });
    cubEl.addEventListener('click', (e) => { if (e.target === cubEl || e.target.closest('[data-cub-close]')) cubClose(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !cubEl.hidden) cubClose(); });
    cubForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = cubForm.email.value.trim();
      const btn = cubForm.querySelector('[type="submit"]');
      cubErr.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { cubErr.textContent = 'Please enter a valid email address.'; cubErr.hidden = false; return; }
      btn.disabled = true;
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${cubEl.dataset.company}`, {
          method: 'POST',
          headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Lulla Cub notify card', profile: { data: { type: 'profile', attributes: { email } } } },
            relationships: { list: { data: { type: 'list', id: cubEl.dataset.list } } } } }),
        });
        if (!res.ok) throw new Error(res.status);
        clarityEvent('cub_signup');
        cubForm.hidden = true;
        cubEl.querySelector('[data-cub-done]').hidden = false;
      } catch (x) {
        cubErr.textContent = 'Something went wrong there. Please try again.';
        cubErr.hidden = false;
      }
      btn.disabled = false;
    });
  }

  /* ---------- 10% off popup: opens from the "10% off first order" link, subscribes to Klaviyo, shows the code ---------- */
  const pop = document.querySelector('[data-lulla-popup]');
  if (pop) {
    const steps = { form: pop.querySelector('[data-pu-step="form"]'), code: pop.querySelector('[data-pu-step="code"]') };
    const err = pop.querySelector('[data-pu-err]');
    const code = pop.dataset.code;
    const remember = (v) => { try { if (v) localStorage.setItem('lulla10', '1'); return localStorage.getItem('lulla10') === '1'; } catch (e) { return false; } };
    const step = (name) => { Object.entries(steps).forEach(([k, el]) => { el.hidden = k !== name; }); };
    const open = () => {
      clarityEvent('popup_open');
      step(remember() ? 'code' : 'form');
      pop.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      const input = pop.querySelector('.pu-in');
      if (input && !steps.form.hidden && window.matchMedia('(hover: hover)').matches) input.focus();
    };
    // opened from the cart drawer's 10% link, the page under the drawer must stay locked
    const close = () => { pop.classList.remove('is-open'); document.documentElement.style.overflow = document.querySelector('[data-lulla-cart].is-open') ? 'hidden' : ''; };
    document.querySelectorAll('[data-signup]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); open(); }));
    pop.querySelectorAll('[data-pu-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });

    pop.querySelector('[data-pu-form]').addEventListener('submit', async (e) => {
      e.preventDefault();
      const form = e.currentTarget;
      const email = form.email.value.trim();
      const btn = form.querySelector('[type="submit"]');
      err.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; return; }
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Unlocking…';
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${pop.dataset.company}`, {
          method: 'POST',
          headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Lulla 10% popup', profile: { data: { type: 'profile', attributes: { email } } } },
            relationships: { list: { data: { type: 'list', id: pop.dataset.list } } } } }),
        });
        if (!res.ok) throw new Error(res.status);
        remember(true);
        clarityEvent('popup_signup');
        step('code');
      } catch (x) {
        err.textContent = 'Something went wrong there. Please try again.';
        err.hidden = false;
      }
      btn.disabled = false;
      btn.textContent = label;
    });

    pop.querySelector('[data-pu-copy]').addEventListener('click', async (e) => {
      const b = e.currentTarget;
      try { await navigator.clipboard.writeText(code); b.textContent = 'Copied'; } catch (x) { b.textContent = code; }
      setTimeout(() => { b.textContent = 'Copy'; }, 2000);
    });
    // /discount/CODE stores the code for checkout; it redirects to a full page, so don't make the shopper wait on it
    pop.querySelector('[data-pu-apply]').addEventListener('click', () => {
      fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart.js`, { credentials: 'same-origin', keepalive: true })
        .then(() => document.dispatchEvent(new CustomEvent('lulla:cart-refresh')))  // the drawer shows the code row
        .catch(() => { /* still works typed in at checkout */ });
      clarityEvent('popup_apply_code');
      close();
    });
  }

  /* ---------- Instagram strip (29 Oct 2026, ported from the Zenith homepage results row) ----------
     The drift is the CSS animation ugcScroll on a two-copy track (translateX(-50% - half a gap)), so the browser runs it
     on the compositor and it never stutters. This script only scrubs that same animation through Animation.currentTime
     while someone drags, swipes or wheels sideways: the tiles follow the finger, a throw coasts with iOS-style inertia,
     and 2.5s after the last input the drift eases back in. Holding is the data-held attribute (CSS play-state), never
     Animation.pause(), so the mouse-hover pause keeps working. Reduced motion: no animation, a plain swipeable row. */
  document.querySelectorAll('.ugc-view').forEach((view) => {
    const track = view.querySelector('.ugc-track');
    if (!track || typeof track.getAnimations !== 'function') return;
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    const anim = () => (still.matches ? null : track.getAnimations().find((a) => a.animationName === 'ugcScroll') || null);
    const wrap = (t, d) => { const w = t % d; return w < 0 ? w + d : w; };  // a negative time snaps the track back to 0
    // move the tiles by px (positive = rightwards, the way a finger drags them)
    const shiftBy = (px) => {
      const a = anim();
      const d = a && a.effect && a.effect.getComputedTiming().duration;
      // one copy is half the track plus half a gap (the keyframes end at -50% - 10px)
      const copy = (track.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0)) / 2;
      if (!a || typeof d !== 'number' || d <= 0 || copy <= 0) return false;
      a.currentTime = wrap((typeof a.currentTime === 'number' ? a.currentTime : 0) - (px / copy) * d, d);
      return true;
    };

    let resumeTimer = 0;
    let rampFrame = 0;
    let motionFrame = 0;
    let busy = false;  // a press or coast is running, so the resume waits
    const setRate = (a, r) => { if (a && a.playbackRate !== r) a.playbackRate = r; };
    const stopRamp = () => { if (rampFrame) cancelAnimationFrame(rampFrame); rampFrame = 0; setRate(anim(), 1); };
    const stopMotion = () => { if (motionFrame) cancelAnimationFrame(motionFrame); motionFrame = 0; };
    const hold = () => { clearTimeout(resumeTimer); stopRamp(); view.dataset.held = ''; };
    // ease the drift back in from rest (smoothstep)
    const rampUp = () => {
      const a = anim();
      if (!a) return;
      const start = performance.now();
      const frame = (now) => {
        const t = (now - start) / 1200;
        if (t >= 1) { rampFrame = 0; setRate(a, 1); return; }
        setRate(a, Math.max(0.02, t * t * (3 - 2 * t)));
        rampFrame = requestAnimationFrame(frame);
      };
      setRate(a, 0.02);
      rampFrame = requestAnimationFrame(frame);
    };
    const scheduleResume = () => {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        if (busy || !('held' in view.dataset)) return;
        delete view.dataset.held;
        rampUp();
      }, 2500);
    };
    // carry a released drag's velocity (px/ms) into a decaying coast
    const coast = (velocity) => {
      stopMotion();
      busy = true;
      let v = Math.max(-4, Math.min(4, velocity));
      let last = performance.now();
      const frame = (now) => {
        const dt = Math.max(0, Math.min(64, now - last));
        last = now;
        if (!shiftBy(v * dt)) v = 0;
        v *= Math.pow(0.998, dt);
        if (Math.abs(v) < 0.02) { motionFrame = 0; busy = false; scheduleResume(); return; }
        motionFrame = requestAnimationFrame(frame);
      };
      motionFrame = requestAnimationFrame(frame);
    };

    let pointerId = -1;
    let pointerType = '';
    let startX = 0;
    let lastX = 0;
    let lastT = 0;
    let dragging = false;
    let velocity = 0;
    const endPress = (throwIt) => {
      pointerId = -1;
      const was = dragging;
      dragging = false;
      delete view.dataset.dragging;
      busy = false;
      if (throwIt && was && performance.now() - lastT < 80 && Math.abs(velocity) > 0.02) coast(velocity);
      else scheduleResume();
      velocity = 0;
    };
    view.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (pointerId !== -1 && e.pointerType !== 'mouse' && pointerType !== 'mouse') { endPress(false); return; }  // a pinch
      pointerId = e.pointerId;
      pointerType = e.pointerType;
      startX = lastX = e.clientX;
      lastT = performance.now();
      velocity = 0;
      dragging = false;
      busy = true;
      stopMotion();
      hold();
      if (e.pointerType !== 'touch') { try { view.setPointerCapture(e.pointerId); } catch (x) { /* synthetic pointer */ } }
    });
    view.addEventListener('pointermove', (e) => {
      if (e.pointerId !== pointerId) return;
      const now = performance.now();
      const dx = e.clientX - lastX;
      const dt = now - lastT;
      lastX = e.clientX;
      lastT = now;
      if (!dragging && Math.abs(e.clientX - startX) > 8) { dragging = true; view.dataset.dragging = ''; }
      if (dt > 0) velocity = 0.7 * (dx / dt) + 0.3 * velocity;
      if (!shiftBy(dx) && pointerType === 'mouse') view.scrollLeft -= dx;  // reduced motion: the row scrolls natively
    });
    view.addEventListener('pointerup', (e) => { if (e.pointerId === pointerId) endPress(true); });
    view.addEventListener('pointercancel', (e) => { if (e.pointerId === pointerId) endPress(false); });  // the page scrolled instead
    view.addEventListener('lostpointercapture', (e) => { if (e.target === view && e.pointerId === pointerId) endPress(false); });
    view.addEventListener('contextmenu', (e) => { if (pointerType && pointerType !== 'mouse') e.preventDefault(); });
    view.addEventListener('dragstart', (e) => e.preventDefault());
    // sideways wheel / trackpad only; vertical scrolls the page
    view.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || !anim()) return;
      e.preventDefault();
      const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? view.clientWidth : 1;
      if (pointerId === -1) { stopMotion(); busy = false; }
      hold();
      shiftBy(-e.deltaX * unit);
      scheduleResume();
    }, { passive: false });
  });

  /* ---------- product cards (collections, Best sellers, favourites) ---------- */
  document.addEventListener('click', async (e) => {
    const sw = e.target.closest('.pc-sw img[data-variant-id]');
    if (sw) {
      e.preventDefault();
      const card = sw.closest('[data-card]');
      card.querySelectorAll('.pc-sw img').forEach((x) => x.classList.toggle('on', x === sw));
      const img = card.querySelector('[data-card-img]');
      if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; }
      const btn = card.querySelector('[data-card-add]');
      if (btn) btn.dataset.cardAdd = sw.dataset.variantId;
      return;
    }
    const add = e.target.closest('[data-card-add]');
    if (!add) return;
    e.preventDefault();
    const was = add.textContent;
    add.disabled = true;
    add.textContent = 'Adding…';
    try {
      await json(root + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: +add.dataset.cardAdd, quantity: 1, properties: { _added_from: 'card' } }] }) });
      clarityEvent('add_to_cart');
      clarityEvent('add_to_cart_card');
      await new Promise((res) => { document.dispatchEvent(new CustomEvent('lulla:cart-open', { detail: { done: res } })); setTimeout(res, 6000); });  // resolves once the drawer is in
    } catch (err) {
      alert(err.message);
    } finally {
      add.disabled = false;
      add.textContent = was;
    }
  });

  /* ---------- site-wide cart drawer ---------- */
  const cartEl = document.querySelector('[data-lulla-cart]');
  if (!cartEl) return;
  cartEl.hidden = false;
  const $ = (s) => cartEl.querySelector(s);
  const upHandles = JSON.parse(cartEl.dataset.ups || '[]');
  const upsRank = JSON.parse(cartEl.dataset.upsRank || '[]');
  const upRank = ({ p, v }) => { const k = upsRank.indexOf(p.handle + ':' + v.title); const h = upsRank.indexOf(p.handle); return k >= 0 ? k : h >= 0 ? h : upsRank.length; };
  const xsBlurbs = JSON.parse(cartEl.dataset.xs || '{}');
  const productCache = {};
  const getProduct = (h) => productCache[h] || (productCache[h] = json(root + 'products/' + h + '.js').catch(() => null));
  let lastFocus = null;

  const itemHTML = (it, i) => `
<div style="display: flex; gap: 14px; padding: 14px 0; border-bottom: 1px solid #f1e8e0">
<button type="button" class="ln-open" data-view="${esc(it.handle)}" data-vid="${it.variant_id}" aria-label="View ${esc(it.product_title)} photos" style="flex: none"><img src="${esc(sized(it.image, 200))}" alt="" style="width: 104px; height: 104px; border-radius: 14px; object-fit: cover; background: #f8f0eb; display: block"></button>
<div style="flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 4px">
<div style="display: flex; justify-content: space-between; gap: 10px"><button type="button" class="ln-open" data-view="${esc(it.handle)}" data-vid="${it.variant_id}" style="font-size: 15px; font-weight: 720; line-height: 1.25">${esc(it.product_title)}</button><span style="font-size: 15px; font-weight: 720; white-space: nowrap">${money(it.original_line_price)}</span></div>
<span style="font-size: 13px; color: #5a4e45">${esc(it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '')}</span>
<div style="display: flex; align-items: center; justify-content: space-between; margin-top: 4px"><div class="qty"><button type="button" aria-label="Decrease" data-qty="${i}" data-to="${it.quantity - 1}">−</button><span>${it.quantity}</span><button type="button" aria-label="Increase" data-qty="${i}" data-to="${it.quantity + 1}">+</button></div><button type="button" class="cd-link" data-qty="${i}" data-to="0">Remove</button></div>
</div>
</div>`;
  // one card per colour; the variant's own photo, with its colour under the name
  const upHTML = ({ p, v }) => `<div class="ups-card"><button type="button" class="ln-open" data-view="${esc(p.handle)}" data-vid="${v.id}" aria-label="View ${esc(p.title)} photos"><img src="${esc(sized((v.featured_image && v.featured_image.src) || p.featured_image, 300))}" alt=""></button><button type="button" class="ln-open" data-view="${esc(p.handle)}" data-vid="${v.id}" style="font-size: 13px; font-weight: 720; line-height: 1.25">${esc(p.title)}</button>${p.variants.length > 1 ? `<span style="font-size: 12px; color: #5a4e45; line-height: 1.25; min-height: 2.5em">${esc(v.title)}</span>` : '<span style="min-height: 2.5em"></span>'}<span style="font-size: 13px; font-weight: 640">${money(v.price)} ${v.compare_at_price > v.price ? `<s style="color: #5a4e45; font-weight: 560">${money(v.compare_at_price)}</s>` : ''}</span><button type="button" class="add" data-add="${v.id}">+ Add</button></div>`;
  const xsHTML = (p) => `<div style="display: flex; align-items: center; gap: 12px; padding: 8px 0"><img src="${esc(sized(p.featured_image, 120))}" alt="" style="width: 56px; height: 56px; border-radius: 12px; object-fit: cover; background: #f8f0eb; flex: none"><div style="flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 2px"><b style="font-size: 14px; font-weight: 720; line-height: 1.25">${esc(p.title)}</b><span style="font-size: 13px; color: #5a4e45">${esc(xsBlurbs[p.handle] || '')}</span><span style="font-size: 13px; font-weight: 640">${money(p.price)}</span></div><button type="button" class="add add-sm" data-add="${p.variants[0].id}">+ Add</button></div>`;

  const refreshBubble = () => fetch(root + '?sections=cart-icon-bubble').then((r) => r.json()).then((s) => {
    const el = document.getElementById('cart-icon-bubble');
    if (!el || !s['cart-icon-bubble']) return;
    const tmp = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
    const inner = tmp.querySelector('.shopify-section');
    el.innerHTML = (inner || tmp.body).innerHTML;
  }).catch(() => {});

  // Goal bar: free shipping with any order, then Shopify automatic discounts by number of Lullas ([[2, 9], ...] in data-goals).
  // On progress the fill glides on with a shimmer, the reached dot pops and the headline slides in (CSS in lulla-pdp.css).
  const goals = JSON.parse(cartEl.dataset.goals || '[]');
  let lastLullas = null;
  const goalBar = (items, goalAmt) => {
    const bar = $('[data-cd-goal]');
    if (!bar) return;
    const lullas = items.filter((it) => /^Sleepy /.test(it.product_title)).reduce((s, it) => s + it.quantity, 0);
    const reached = goals.filter(([n]) => lullas >= n).pop();
    const next = goals.find(([n]) => lullas < n);
    const need = next ? next[0] - lullas : 0;
    bar.hidden = lullas < 2;  // a half-full bar made one-Lulla carts feel unfinished; the row below asks for the second instead
    $('[data-gb-win]').textContent = reached ? `$${reached[1]} off unlocked` : 'Free shipping unlocked';
    $('[data-gb-next]').textContent = next ? `Add ${need}${lullas ? ' more' : ''} Lulla${need > 1 ? 's' : ''} for $${next[1]} off` : 'Free shipping included';
    const upsH = $('[data-cd-ups-h]'), upsSub = $('[data-cd-ups-sub]');  // "Complete the set" copy follows the next goal
    const one = lullas === 1 && goals.length;
    if (upsH) upsH.dataset.full = one ? `Add a second Lulla, save $${goals[0][1]}` : 'Complete the set';
    if (upsSub) upsSub.dataset.full = one ? `The $${goals[0][1]} comes off by itself when there are two in your cart.` : next ? $('[data-gb-next]').textContent + '.' : 'Your biggest saving is already in the cart.';
    const steps = [...bar.querySelectorAll('[data-gb-step]')];
    const done = steps.filter((s) => (+s.dataset.gbStep === 1 ? items.length > 0 : lullas >= +s.dataset.gbStep)).length;
    steps.forEach((s, i) => {
      const isNext = i === done;
      s.classList.toggle('is-done', i < done); s.querySelector('.gb-dot').classList.toggle('is-done', i < done);
      s.classList.toggle('is-next', isNext); s.querySelector('.gb-dot').classList.toggle('is-next', isNext);
    });
    $('[data-gb-fill]').style.width = (steps.length > 1 ? Math.max(done - 1, 0) / (steps.length - 1) * 100 : 0) + '%';
    if (lullas !== lastLullas) {  // restart the shimmer and headline animations
      ['[data-gb-fill]', '[data-gb-msg]'].forEach((sel, k) => { const el = $(sel); el.classList.remove(k ? 'is-in' : 'is-shine'); void el.offsetWidth; el.classList.add(k ? 'is-in' : 'is-shine'); });
      lastLullas = lullas;
    }
    const row = $('[data-cd-goal-row]');
    if (row) {
      row.hidden = !(goalAmt > 0);
      $('[data-cd-goal-chip]').textContent = (reached && ['Duo', 'Trio', 'Quartet'][reached[0] - 2]) || 'Duo';
      $('[data-cd-goal-amt]').textContent = money(goalAmt);
    }
  };

  let tenJustApplied = false, tenTried = false;  // 10% in the drawer, see tenAuto below
  const render = async (cart) => {
    const items = cart.items || [];
    setEta(items);
    $('[data-cd-count]').textContent = cart.item_count;
    $('[data-cd-empty]').hidden = items.length > 0;
    $('[data-cd-quarter]').textContent = '$' + (cart.total_price / 400).toFixed(2);
    $('[data-cd-checkout]').textContent = 'Checkout';
    $('[data-cd-checkout]').toggleAttribute('aria-disabled', !items.length);
    const inCart = new Set(items.map((it) => it.handle));
    // the struck total is the $99 line prices (compare-at prices aren't the real price); the saving is only real discounts
    // "In your cart" plus bigger photos keep the cart lines apart from the Complete the set suggestions below
    $('[data-cd-items]').innerHTML = (items.length ? '<span class="eyebrow" style="color: #5a4e45; padding-top: 4px">In your cart</span>' : '') + items.map(itemHTML).join('');
    const saving = cart.total_discount || 0;
    // discount code from the 10% popup (or any code Shopify has stored for checkout); the rest is automatic (Lulla rewards)
    const codeEl = $('[data-cd-code]');
    const applied = (cart.discount_codes || []).find((d) => d.applicable);
    // each line's discounts list carries both product and order discounts (NEWLULLA10 is an order discount since 23 Oct 2026)
    const codeAmt = applied ? items.reduce((s, it) => s + (it.discounts || [])
      .filter((d) => d.title.toUpperCase() === applied.code.toUpperCase()).reduce((t, d) => t + d.amount, 0), 0) : 0;
    const goalAmt = (cart.total_discount || 0) - codeAmt;
    if (codeEl) {
      codeEl.hidden = !(applied && items.length && codeAmt > 0);
      if (applied) { $('[data-cd-code-name]').textContent = applied.code; $('[data-cd-code-amt]').textContent = money(codeAmt); }
    }
    goalBar(items, goalAmt);
    // "First order? Get 10% off" until a code is on the cart; it opens the email field in the drawer (tenOff below)
    const nudge = $('[data-cd-nudge]'), inl = $('[data-cd-inl]');
    if (nudge) nudge.hidden = !!applied || !items.length || (inl && !inl.hidden);
    if (inl && (applied || !items.length)) inl.hidden = true;
    if (applied && tenJustApplied) {
      tenJustApplied = false;
      const chip = $('[data-cd-code-name]');  // a glare runs across the coupon chip
      if (chip) { chip.classList.remove('cd-glare'); void chip.offsetWidth; chip.classList.add('cd-glare'); setTimeout(() => chip.classList.remove('cd-glare'), 2600); }
    }
    if (!applied && items.length) tenAuto();
    // gift wrap tick box: ticked while a Gift Wrap line is in the cart; only shown once there's something to wrap
    const gift = $('[data-cd-gift]');
    if (gift) {
      const gLine = items.find((it) => it.handle === 'gift-wrap');
      gift.hidden = !items.some((it) => it.handle !== 'gift-wrap');
      $('[data-cd-gift-box]').checked = !!gLine;
      const msg = $('[data-cd-gift-msg]');
      msg.hidden = !gLine;
      if (gLine && document.activeElement !== msg) msg.value = (gLine.properties && gLine.properties['Gift message']) || '';
      gift.dataset.key = gLine ? gLine.key : '';
      gift.dataset.from = (gLine && gLine.properties && gLine.properties._added_from) || 'drawer';
    }
    $('[data-cd-subtotal]').innerHTML = (saving > 0 ? `<s style="color: #5a4e45; font-weight: 560; margin-right: 6px">${money(cart.total_price + saving)}</s>` : '') + money(cart.total_price);
    $('[data-cd-save]').hidden = saving <= 0;
    $('[data-cd-saving]').textContent = money(saving);
    const inCartVariants = new Set(items.map((it) => it.variant_id));
    const ups = (await Promise.all(upHandles.map(getProduct))).filter(Boolean)
      .flatMap((p) => p.variants.filter((v) => v.available && !inCartVariants.has(v.id)).map((v) => ({ p, v })))
      .sort((x, y) => upRank(x) - upRank(y))  // best sellers first
      .slice(0, 3);  // three that fit side by side, so Checkout stays close
    // an empty cart shows the same row as "Add a Lulla" (copy lives in data-full / data-empty) and no footer
    const empty = !items.length;
    ['[data-cd-ups-h]', '[data-cd-ups-sub]'].forEach((sel) => { const el = $(sel); if (el) el.textContent = empty ? el.dataset.empty : el.dataset.full; });
    const foot = $('[data-cd-foot]');
    if (foot) foot.style.display = empty ? 'none' : '';
    $('[data-cd-ups-wrap]').hidden = !ups.length;
    $('[data-cd-ups]').innerHTML = ups.map(upHTML).join('');
    const xs = (await Promise.all(Object.keys(xsBlurbs).filter((h) => !inCart.has(h)).map(getProduct))).filter((p) => p && p.available).slice(0, 3);
    $('[data-cd-xs-wrap]').hidden = !items.length || !xs.length;
    $('[data-cd-xs]').innerHTML = xs.map(xsHTML).join('');
  };

  const load = () => json(root + 'cart.js').then(render);

  // gift wrap tick box (28 Oct 2026): adds or removes the Gift Wrap line; the message saves on that line when it changes
  const giftEl = $('[data-cd-gift]');
  if (giftEl) {
    const post = (url, body) => json(root + url, { method: 'POST', body: JSON.stringify(body) });
    $('[data-cd-gift-box]').addEventListener('change', async (e) => {
      const on = e.currentTarget.checked;
      busy(true);
      try {
        if (on) await post('cart/add.js', { items: [{ id: +giftEl.dataset.variantId, quantity: 1, properties: { _added_from: 'drawer' } }] });
        else if (giftEl.dataset.key) await post('cart/change.js', { id: giftEl.dataset.key, quantity: 0 });
        clarityEvent(on ? 'drawer_gift_on' : 'drawer_gift_off');
        await load();
        refreshBubble();
      } catch (x) { e.currentTarget.checked = !on; }
      busy(false);
    });
    $('[data-cd-gift-msg]').addEventListener('change', (e) => {
      if (!giftEl.dataset.key) return;
      const v = e.currentTarget.value.trim();
      const props = { _added_from: giftEl.dataset.from || 'drawer' };  // keep where the gift wrap was added
      if (v) { props['Gift message'] = v; clarityEvent('gift_message_typed', { gift_from: 'drawer' }); }
      post('cart/change.js', { id: giftEl.dataset.key, quantity: 1, properties: props }).then(load).catch(() => {});
    });
  }

  // 10% in the drawer (27 Oct 2026): an email field in place of the popup. It subscribes to the same Klaviyo list,
  // remembers the signup like the popup does, applies NEWLULLA10 and animates the saving in. People who already signed
  // up on this browser get the code applied by itself, once per page.
  const popEl = document.querySelector('[data-lulla-popup]');
  const tenCode = (popEl && popEl.dataset.code) || 'NEWLULLA10';
  const tenSigned = () => { try { return localStorage.getItem('lulla10') === '1'; } catch (e) { return false; } };
  const tenApply = () => fetch(`${root}discount/${encodeURIComponent(tenCode)}?redirect=${root}cart.js`, { credentials: 'same-origin' });
  function tenAuto() {
    if (tenTried || !tenSigned()) return;
    tenTried = true;
    tenApply().then(() => { tenJustApplied = true; return load(); }).catch(() => {});
  }
  const tenBtn = $('[data-cd-10]'), tenForm = $('[data-cd-inl]');
  if (tenBtn && tenForm) {
    tenBtn.addEventListener('click', () => {
      if (tenSigned()) { tenTried = true; tenApply().then(() => { tenJustApplied = true; return load(); }).catch(() => {}); return; }
      $('[data-cd-nudge]').hidden = true;
      tenForm.hidden = false;
      clarityEvent('drawer_10_open');
      if (window.matchMedia('(hover: hover)').matches) tenForm.email.focus();
    });
    tenForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = tenForm.email.value.trim();
      const btn = tenForm.querySelector('button');
      const note = $('[data-cd-inl-note]');
      const fail = (msg) => { note.textContent = msg; note.classList.add('is-err'); btn.disabled = false; btn.textContent = 'Apply 10%'; };
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return fail('Please enter a valid email address.');
      note.textContent = 'Sleep tips and offers from Lulla. Unsubscribe anytime.';
      note.classList.remove('is-err');
      btn.disabled = true;
      btn.textContent = 'Applying…';
      try {
        if (popEl) {
          const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${popEl.dataset.company}`, {
            method: 'POST',
            headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Lulla cart drawer 10%', profile: { data: { type: 'profile', attributes: { email } } } },
              relationships: { list: { data: { type: 'list', id: popEl.dataset.list } } } } }),
          });
          if (!res.ok) throw new Error(res.status);
        }
        try { localStorage.setItem('lulla10', '1'); } catch (x) { /* private mode */ }
        clarityEvent('drawer_10_signup');
        await tenApply();
        // the field folds away: pin its height, then let the transition take it to nothing
        tenForm.style.height = tenForm.offsetHeight + 'px';
        void tenForm.offsetWidth;
        tenForm.classList.add('is-out');
        tenForm.style.height = '0px';
        tenForm.style.marginTop = '-8px';  // the footer's 8px gap closes up too
        await new Promise((r) => setTimeout(r, 400));
        tenForm.hidden = true;
        tenForm.classList.remove('is-out');
        tenForm.style.height = tenForm.style.marginTop = '';
        tenJustApplied = true;
        tenTried = true;
        await load();
      } catch (x) {
        fail('Something went wrong there. Please try again.');
      }
    });
  }
  document.addEventListener('lulla:cart-refresh', () => { load().catch(() => {}); });  // e.g. the 10% popup applied its code

  // "Order today, arrives by Fri 31 Oct": ships from Brisbane in 2-5 business days, so promise the 4th business day.
  // Pup and Elephant (on their own or in a Duo) count from the pre-order ship date until that date passes
  const PRE_SHIP = '2026-12-11';
  const etaEl = $('[data-cd-eta]');
  const setEta = (items) => {
    if (!etaEl) return;
    const today = new Date();
    const pre = today < new Date(PRE_SHIP + 'T00:00:00') && (items || []).some((it) => /Pup|Elephant/.test(it.product_title + ' ' + (it.variant_title || '')));
    const d = pre ? new Date(PRE_SHIP + 'T00:00:00') : today;
    for (let n = 0; n < 4;) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n++; }
    etaEl.textContent = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()] + ' ' + d.getDate() + ' '
      + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()];
    $('[data-cd-eta-row]').hidden = false;
  };
  setEta([]);
  const busy = (on) => $('[data-cd-body]').classList.toggle('cd-loading', on);

  // The drawer only slides in once it holds the current cart, so lines, goal bar and upsells never pop in and push the
  // drawer around on screen (that counted as layout shift on phones). It is rendered once at idle so the cart icon opens
  // it instantly; after an add-to-cart it waits for the fresh cart (the button already says "Adding…").
  let warming = null, ready = false;
  const show = () => {
    lastFocus = document.activeElement;
    cartEl.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    $('.cd').focus({ preventScroll: true });
  };
  const open = async (e) => {
    const fresh = !!(e && e.type === 'lulla:cart-open');
    if (fresh || !ready) { try { await (fresh ? load() : warming || load()); ready = true; } catch (err) { /* show what we have */ } show(); }
    if (e && e.detail && e.detail.done) e.detail.done();
    else { show(); busy(true); try { await load(); } finally { busy(false); } }
    refreshBubble();
  };
  const warm = () => { warming = load().then(() => { ready = true; }).catch(() => null); };
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 2500);
  const close = () => {
    cartEl.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  /* ---------- photo view: a cart line or Complete the set card opens that Lulla's photos over the dimmed cart ---------- */
  // Built on first use; photos come from the product JSON the drawer already fetched, so nothing loads up front.
  let lb = null;
  const lbClose = () => { if (lb) lb.hidden = true; };
  const lbOpen = async (handle, vid, canAdd) => {  // canAdd: opened from Complete the set, so the view offers Add to cart
    const p = await getProduct(handle);
    if (!p) return;
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'cd-lb';
      lb.setAttribute('role', 'dialog');
      lb.innerHTML = '<button type="button" class="cd-lb-x" aria-label="Back to cart">×</button><div class="cd-lb-gal"></div><div class="cd-lb-dots" aria-hidden="true"></div><span class="cd-lb-cap"></span><button type="button" class="btn cd-lb-add" hidden>Add to cart</button>';
      $('.cd').appendChild(lb);
      lb.addEventListener('click', (ev) => { if (ev.target === lb || ev.target.closest('.cd-lb-x')) { ev.stopPropagation(); lbClose(); } });
      const gal = lb.querySelector('.cd-lb-gal');
      let shown = 0;
      gal.addEventListener('scroll', () => {
        const k = Math.round(gal.scrollLeft / gal.clientWidth);
        if (k === shown) return;
        shown = k;
        lb.querySelectorAll('.cd-lb-dots span').forEach((d, j) => d.classList.toggle('is-on', j === k));
      }, { passive: true });
    }
    const v = p.variants.find((x) => x.id === +vid) || p.variants[0];
    const imgs = (p.images || []).map((u) => u.split('?')[0]);
    const file = (u) => u.split('?')[0].split('/').pop();  // the product list and the variant use different hosts for the same file
    const first = v.featured_image ? imgs.findIndex((u) => file(u) === file(v.featured_image.src)) : 0;
    const list = first > 0 ? imgs.slice(first).concat(imgs.slice(0, first)) : imgs;  // the tapped colour's photo first
    lb.setAttribute('aria-label', p.title + ' photos');
    lb.querySelector('.cd-lb-gal').innerHTML = list.map((u, k) => `<img src="${esc(sized(u, 800))}" alt="${esc(p.title)} photo ${k + 1}"${k ? ' loading="lazy"' : ''}>`).join('');
    lb.querySelector('.cd-lb-gal').scrollLeft = 0;
    lb.querySelector('.cd-lb-dots').innerHTML = list.length > 1 ? list.map((_, k) => `<span${k ? '' : ' class="is-on"'}></span>`).join('') : '';
    lb.querySelector('.cd-lb-cap').textContent = p.title + (p.variants.length > 1 ? ' · ' + v.title : '');
    const addBtn = lb.querySelector('.cd-lb-add');
    addBtn.hidden = !canAdd;
    addBtn.dataset.add = v.id;  // the drawer's own [data-add] handler adds it
    lb.hidden = false;
    lb.querySelector('.cd-lb-x').focus({ preventScroll: true });
    clarityEvent('cart_photo_view', { photo_view_product: handle });
  };

  cartEl.addEventListener('click', async (e) => {
    const view = e.target.closest('[data-view]');
    if (view) { lbOpen(view.dataset.view, view.dataset.vid, !!view.closest('.ups-card')); return; }
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    if (e.target.closest('[data-cd-checkout]')) { clarityEvent('checkout_click'); return; }
    const q = e.target.closest('[data-qty]');
    const a = e.target.closest('[data-add]');
    if (!q && !a) return;
    busy(true);
    try {
      const cart = q
        ? await json(root + 'cart/change.js', { method: 'POST', body: JSON.stringify({ line: +q.dataset.qty + 1, quantity: Math.max(0, +q.dataset.to) }) })
        : (await json(root + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: +a.dataset.add, quantity: 1, properties: { _added_from: 'drawer' } }] }) }), await json(root + 'cart.js'));
      if (a) { clarityEvent('add_to_cart'); clarityEvent(a.closest('.cd-lb') ? 'add_to_cart_photo_view' : 'add_to_cart_drawer_upsell'); }
      if (a && a.closest('.cd-lb')) lbClose();  // back to the cart, now holding it
      await render(cart);
      refreshBubble();
    } catch (err) {
      alert(err.message);
    } finally {
      busy(false);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !cartEl.classList.contains('is-open')) return;
    if (lb && !lb.hidden) lbClose(); else close();  // Escape backs out of the photo view first
  });
  document.addEventListener('lulla:cart-open', open);
  // header cart icon and any link to /cart open the drawer instead (capture phase, so Dawn's own drawer never opens)
  document.addEventListener('click', (e) => {
    const link = e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href="' + root + 'cart"]');
    if (!link || e.metaKey || e.ctrlKey || link.closest('[data-lulla-cart]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);
})();
